export default __webpack_public_path__ + "6c467dd9e1f90dcc9f9db85d090d6356.webp";